import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VideoPlayerDialog } from '../../home/home.component';
import { StepFourDialog1 } from 'src/pages/agra/agra.component';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { LoginService } from 'src/providers/login.service';

@Component({
  selector: 'app-cat-journey',
  templateUrl: './cat-journey.component.html',
  styleUrls: ['./cat-journey.component.scss']
})
export class CatJourneyComponent implements OnInit{
  strategyTab: any = 0;

  @Input('pageType') pageType:any

  constructor(public dialog: MatDialog,  @Inject(LOCAL_STORAGE) public sessionStorage: any, 
  public loginService: LoginService, ){}

  ngOnInit(): void {
    this.token = this.sessionStorage.getItem('usertoken');
    if (this.token) {
      this.userData = JSON.parse(this.sessionStorage.getItem('userData'));

    }
    this.getProfileData()
  }

  playVideo() {
    const dialogref = this.dialog.open(VideoPlayerDialog, {
      width: '800px',
      data: { video: 'https://www.youtube.com/embed/_LUgZG3q8eA?rel=0', type: 'toppers' },
      panelClass: ['video-dialog', 'video-dilogue2']
    })
    dialogref.afterClosed().subscribe(result => {

    })
  }
  selectedIndex: any = 1;

  scrollTo(index: any) {
    this.selectedIndex = index;
    var elemnt: any = document.getElementById('syllabus')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }
  token: any;
  userData: any;
  getProfileData() {
    this.loginService.profileData.subscribe(res => {
      this.token = this.sessionStorage.getItem('usertoken');
      if (this.sessionStorage.getItem('userData')) {
        this.userData = JSON.parse(this.sessionStorage.getItem('userData'));
      } else {
        this.userData = '';
        this.token = ''
      }
    })
  }

  
  enquiryForm() {
    const dialog = this.dialog.open(StepFourDialog1, {
      width: '390px',
      panelClass: ['cat-new-form'],
      data: this.pageType
    })

    dialog.afterClosed().subscribe((result: any) => {
      if (result.success) {
      
      }
    })
  }

  scrollToStrattegy(index: any) {
    this.strategyTab = index;
    var elemnt: any = document.getElementById('strategy')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }

  gotocourse() {
    var elemnt: any = document.getElementById('courses')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }

  imock() {
    window.open('https://www.iquanta.in/cat-mock-test', '_blank')
  }

}
